import { getRideApi } from "api";
import {getAuthApi} from "../../api";

export const fetchMe = () => ({
    types: ['FETCH_ME_REQUEST', 'FETCH_ME_SUCCESS', 'FETCH_ME_FAILURE'],
    callAPI: () => getRideApi().fetchMe()
})

export const fetchUserProfile = () => ({
    types: ['FETCH_USER_PROFILE_REQUEST', 'FETCH_USER_PROFILE_SUCCESS', 'FETCH_USER_PROFILE_FAILURE'],
    callAPI: () => getAuthApi().fetchUserProfile()
});